import React, { useState, useEffect } from "react";
import "../../styles/styles.scss";
import Header from "../header/header";
import { GetCompanyInfo } from "../../queries/company-info";
import Footer from "../footer/footer";
import Popup from "../pop-up/pop-up";

const Layout = ({ children }) => {
  const data = GetCompanyInfo();
  const [showPopup, setShowPopup] = useState(false); 
  useEffect(() => {
    setShowPopup(false); // Show popup on page load
  }, []);
  return (
    <>
      <Header data={data} />
      {showPopup && <Popup onClose={() => setShowPopup(false)} />}
      <main className="content">{children}</main>
      <Footer data={data}/>
    </>
  );
};

export default Layout;
